import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import TransactionsService from "../../api/transactions";


export const getTransactions = createAsyncThunk(
  "transactions/get",
  async (args, thunkAPI) => {
    try {
      const response = await TransactionsService.getTransactions(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getTransactionsRaw = createAsyncThunk(
  "transactions/getRaw",
  async (args, thunkAPI) => {
    try {
      const response = await TransactionsService.getTransactionsRaw(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getTransactionDetail = createAsyncThunk(
  "transactionDetail/get",
  async (args, thunkAPI) => {
    try {
      const response = await TransactionsService.getTransactionDetail(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const refundTransaction = createAsyncThunk(
  "transaction/refund",
  async (args, thunkAPI) => {
    try {
      const response = await TransactionsService.refundTransaction(args);
      return response;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data ) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const initialState = {
  results: [],
  count: 0,
  next: null,
  previous: null,
  selectedTransaction: null,
  error: null,
  loading: false,
  loadingDetail: false,
};

const transactionsSlice = createSlice({
  name: "transactions",
  initialState,
  extraReducers: {
    [getTransactions.pending]: (state, action) => {
      state.loading = true;
    },
    [getTransactions.fulfilled]: (state, action) => {
      Object.assign(state, action.payload);
      state.loading = false;
    },
    [getTransactions.rejected]: (state, action) => {
      state.error = "Ekki tókst að sækja færslur";
    },
    [getTransactionDetail.pending]: (state, action) => {
      state.loadingDetail = true;
    },
    [getTransactionDetail.fulfilled]: (state, action) => {
      state.selectedTransaction = action.payload;
      state.loadingDetail = false;
    },
    [getTransactionDetail.rejected]: (state, action) => {
      state.error = "Ekki tókst að sækja færslu";
    },
    [refundTransaction.pending]: (state, action) => {
      console.log("Endurgreiðsla í vinnslu")
    },
    [refundTransaction.fulfilled]: (state, action) => {
      console.log("Endurgreiðsla tókst")
    },
    [refundTransaction.rejected]: (state, action) => {
      state.error = "Ekki tókst að endurgreiða færslu";
    },
    [getTransactionsRaw.pending]: (state, action) => {
      state.loading = true;
    },
    [getTransactionsRaw.fulfilled]: (state, action) => {
      state.results = action.payload
      state.loading = false;
    },
    [getTransactionsRaw.rejected]: (state, action) => {
      state.error = "Ekki tókst að sækja færslur";
    },

  },
});

const { reducer } = transactionsSlice;
export default reducer;